import { axiosInstance } from "./apiInstance";

export const putSwitchGroup = async ({ uuid }) => {
  const response = await axiosInstance.put(
    `api/inkle/company/v1/group/${uuid}/default/`
  );

  return response.data;
};
